import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import LoginService from '@/account/login.service';
import RegisterService from './register.service';
import { EMAIL_ALREADY_USED_TYPE, ORGANIZATION_ALREADY_USED_TYPE, PRIVACY_POLICY_URL, REGISTER_URL } from '@/constants';
import CountryList from '@/shared/static/country-list';
import {StateList, AUStateList} from '@/shared/static/state-list';
import Payment from '@/account/upgrade/payment.vue';
import RegionService from '@/entities/region/region.service';
import { IRegion } from '@/shared/model/region.model';
import ValidationMixin from '@/shared/data/validation-mixin';
import OrganizationService from '@/entities/organization/organization.service';
import { IOrganization } from '@/shared/model/organization.model';

@Component({
  mixins: [ValidationMixin],
  components: {
    Payment
  }
})
export default class Register extends Vue {
  @Inject('registerService') private registerService: () => RegisterService;
  @Inject('loginService') private loginService: () => LoginService;
  @Inject('regionService') private regionService: () => RegionService;
  @Inject('organizationService') private organizationService: () => OrganizationService;

  public registerAccount: any = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    country: undefined,
    state: undefined,
    phoneNumber: undefined,
    password: undefined,
    organizationName: undefined,
    planNickname: undefined,
    region: undefined,
    productCode: undefined,
    resellerId: undefined,
    plans: []
  };
  public error = '';
  public errorEmailExists = '';
  public errorOrgExists = '';
  public success = false;
  public currentLanguage = '';
  public countryList = [];
  public stateList = [];
  public planDescription = null;
  public appsIncluded = '';
  public showEstimate = false;
  public subscriptionSuccess = false;
  public step = 'Register';
  public regions: IRegion[] = [];
  public resellerId = null;
  public reseller: IOrganization = null;
  public loading = false;
  public privacyUrl = PRIVACY_POLICY_URL;

  created(): void {
    this.currentLanguage = this.$store.getters.currentLanguage;
    this.$store.watch(
      () => this.$store.getters.currentLanguage,
      () => {
        this.currentLanguage = this.$store.getters.currentLanguage;
      }
    );

    if (!this.$route.query.partnerId) {
      window.open(
          REGISTER_URL,
          '_self'
        );
    }

    this.registerAccount.planNickname = 'elb_platinum_suite_trial';
    this.registerAccount.productCode = 'Lectora';

    if (this.$route.query.plan) {
      this.registerAccount.planNickname = this.$route.query.plan;
    }

    if (this.$route.query.product) {
      this.registerAccount.productCode = this.$route.query.product;
    }

    if (this.$route.query.partnerId) {
      this.registerAccount.resellerId = this.$route.query.partnerId;
      this.getReseller(this.$route.query.partnerId);
    }

    if (this.$route.query.plans) {
      const plans = this.$route.query.plans as string;
      this.registerAccount.plans = plans.split(',');
    }

    switch (this.registerAccount.planNickname) {
      case 'elb_platinum_suite_trial': {
        this.planDescription = 'Platinum Suite Trial';
        this.appsIncluded = 'Lectora® Online, Lectora® Desktop, ReviewLink™, AssetLibrary (In-App), AssetLibrary (Full Access), Cenario VR';
        break; }
      case 'elb_gold_suite_trial': {
        this.planDescription = 'Gold Suite Trial';
        this.appsIncluded = 'Lectora® Online, Lectora® Desktop, ReviewLink™, AssetLibrary (In-App), AssetLibrary (Full Access)';
        break;
      }
      case 'elb_silver_suite_trial': {
        this.planDescription = 'Silver Suite Trial';
        this.appsIncluded = 'Lectora® Online, ReviewLink™, AssetLibrary (In-App)';
        break;
      }
      case 'elb_platinum_suite': {
        this.planDescription = 'Platinum Suite';
        this.appsIncluded = 'Lectora® Online, Lectora® Desktop, ReviewLink™, AssetLibrary (In-App), AssetLibrary (Full Access), Cenario VR';
        break;
      }
      case 'elb_gold_suite': {
        this.planDescription = 'Gold Suite';
        this.appsIncluded = 'Lectora® Online, Lectora® Desktop, ReviewLink™, AssetLibrary (In-App), AssetLibrary (Full Access)';
        break;
      }
      case 'elb_silver_suite': {
        this.planDescription = 'Silver Suite';
        this.appsIncluded = 'Lectora® Online, ReviewLink™, AssetLibrary (In-App)';
        break;
      }
    }

    this.countryList =  CountryList;
    this.stateList = StateList;

    this.getRegions();
  }

  public accountCreated() {
    this.success = true;
  }

  public countryChanged() {
    this.stateList = StateList;
    if (this.registerAccount.country === 'au') {
      this.stateList = AUStateList;
    }
  }

  public getReseller(resellerId) {
    this.organizationService()
    .find(resellerId)
    .then((res) => {
      this.reseller = res;
    });
  }

  public onDoneCheckout() {
    this.subscriptionSuccess = true;
    this.showEstimate = false;
    this.accountCreated();
  }

  public onCancelCheckout() {
    this.showEstimate = false;
  }

  public continentToRegion(continent: string) {
    let region = null;
    if (this.regions && this.regions.length === 0) {
      return region;
    }

    this.regions.forEach((ele) => {
      if (ele.name === 'United States') {
        region = ele.name;
      }
    });

    if (region == null) {
      return null;
    }

    switch (continent) {
      case 'North America':
      case 'South America': region = this.getRegionKey('United States'); break;
      case 'Asia':
      case 'Australia': region = this.getRegionKey('Australia'); break;
      case 'Africa':
      case 'Europe': region = this.getRegionKey('Europe'); break;
      default: region = this.getRegionKey('United States'); break;
    }

    return region;
  }

  public getRegionKey(displayName) {
    let key = null;
    this.regions.forEach((ele) => {
      if (ele.name === displayName) {
        key = ele.key;
      }
    });

    return key;
  }


  public getRegions() {
    const pvPaginationQuery = {
      page: 0,
      size: 50,
      sort: ['id,asc']
    };

    this.regionService()
    .retrieve(pvPaginationQuery)
    .then((res) => {
      this.regions = res.data;

    });
  }


  public register() {
    this.error = null;
    this.errorOrgExists = null;
    this.errorEmailExists = null;
    this.registerAccount.langKey = 'en';
    if (this.registerAccount.planNickname == null) {
      this.registerAccount.planNickname = 'elb_platinum_suite_trial';
    }

    this.cleanData();

    if (this.reseller) {
      this.registerAccount.region = this.reseller.instanceName;
    }
    this.loading = true;
    this.$recaptcha('register').then((token) => {
      this.registerService()
        .processRegistration(this.registerAccount, token)
        .then(() => {
          // this.success = true;
          if (this.needsPayment()) {
            this.step = 'Subscribe';
            this.showEstimate = true;
          } else {
            this.success = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          this.success = null;
          this.loading = false;
          if (error.response.status === 400 && error.response.data.type === ORGANIZATION_ALREADY_USED_TYPE) {
            this.errorOrgExists = 'ERROR';
          } else if (error.response.status === 400 && error.response.data.type === EMAIL_ALREADY_USED_TYPE) {
            this.errorEmailExists = 'ERROR';
          } else {
            this.error = 'ERROR';
          }
        });
    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });

  }

  public cleanData() {
    const blockSpecialRegex = /[~`!@#$%^&()_={}[\]:;,.<>+\/?-]/g;
    this.registerAccount.firstName = this.registerAccount.firstName.replace(blockSpecialRegex, '');
    this.registerAccount.lastName = this.registerAccount.lastName.replace(blockSpecialRegex, '');
    this.registerAccount.organizationName = this.registerAccount.organizationName.replace(blockSpecialRegex, '');
    this.registerAccount.phoneNumber = this.registerAccount.phoneNumber.replace(blockSpecialRegex, '');

  }

  public needsPayment() {
    return !this.registerAccount.planNickname.includes('trial');
  }

  public openLogin(): void {
    this.$router.push({
      name: 'Signin'
    });
  }

  public openPricing(): void {
    this.$router.push({
      name: 'AccountPlan'
    });
  }

  public blockChars(e) {
    const blockSpecialRegex = /[~`{}[\]:;<>\/]/;
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (blockSpecialRegex.test(key)) {
      e.preventDefault();
      return false;
    }
  }
}
